import { render } from "./bookImageView.vue?vue&type=template&id=340c1ab2&scoped=true&ts=true"
import script from "./bookImageView.vue?vue&type=script&lang=ts"
export * from "./bookImageView.vue?vue&type=script&lang=ts"

import "./bookImageView.vue?vue&type=style&index=0&id=340c1ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340c1ab2"]])

export default __exports__